import React from "react";
import * as M from './Menu-style';

export default class MenuBurger extends React.Component {

   state = {
      lineMove: true
   }

   render() {

      return (
         <M.MenuBurgerItem onClick={this.burgerActive}>
            <M.MenuBurgerLine1 lineRotate={this.state.lineMove} />
            <M.MenuBurgerLine2 lineRotate={this.state.lineMove} />
            <M.MenuBurgerLine3 lineRotate={this.state.lineMove} />
         </M.MenuBurgerItem>
      )
   }
   burgerActive = () => {
      this.setState({ lineMove: !this.state.lineMove })
      if (this.state.lineMove) {
         document.body.style.overflow = "hidden";
         if (window.innerHeight > window.pageYOffset) {
            window.scrollTo(0, window.innerHeight);
         }

      } else {
         document.body.style.overflow = "";
      }
   }


}

